module.exports = __webpack_public_path__ + "img/governance-banner.5599f58a.jpg";